import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            token: localStorage.getItem("Amaar_App_Token"),
            usertype: localStorage.getItem("Amaar_App_User_Type"),
            user_id: localStorage.getItem("Amaar_App_User_Id"),
            userImage: localStorage.getItem("Amaar_App_userImg"),
            userPhone: localStorage.getItem("Amaar_App_userPhone"),
            userName: localStorage.getItem("Amaar_App_userPhone"),
            fullName: localStorage.getItem("Amaar_App_fullName"),
            userCode: localStorage.getItem("Amaar_App_userCode"),
        };
    },
    mutations,
    actions,
    getters,
};